import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
interface AccordionItemData {
  emoji: string;
  title: string;
  items?: string[];
  desc?: string;
}
interface AccordionProps {
  data: AccordionItemData[];
  accent?: string;
}
export function Accordion({
  data,
  accent = "#d4ff00"
}: AccordionProps) {
  const [open, setOpen] = useState<number | null>(0);
  return <div className="flex flex-col gap-2.5" data-id="element-66" data-mp="2n24ftyr679k2">
      {data.map((item, i) => {
      const isOpen = open === i;
      return <div key={i} className="overflow-hidden rounded-2xl border border-white/10 bg-black/60 backdrop-blur-sm" data-id="element-67" data-mp="2w4nhifj7zg4q" data-mpi={i}>
            <button type="button" onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center gap-3 px-4 py-3.5 text-left" aria-expanded={isOpen} data-id="element-68" data-mp="2s3k03olixc1e">
              <span className="text-xl leading-none" data-id="element-69" data-mp="xrdkmdllk93a">{item.emoji}</span>
              <span className="flex-1 text-sm font-bold leading-snug text-white" data-id="element-70" data-mp="3g5x6gen3dl6l">
                {item.title}
              </span>
              <motion.span animate={{
            rotate: isOpen ? 180 : 0
          }} transition={{
            duration: 0.2
          }} className="shrink-0" style={{
            color: accent
          }} data-id="element-71" data-mp="3q29zrbeq5x0t">
                <ChevronDownIcon className="h-5 w-5" data-id="element-72" data-mp="3ngrvh5hxsjw" />
              </motion.span>
            </button>
            <AnimatePresence initial={false} data-id="element-73" data-mp="7niubsj22q08">
              {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: "auto",
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.25
          }} data-id="element-74" data-mp="cnn1gry2q8ds">
                  <div className="border-t border-white/10 px-4 py-3" data-id="element-75" data-mp="2egl0j5ig1x76">
                    {item.desc && <p className="mb-2 text-sm text-white/70" data-id="element-76" data-mp="2jfxndq9bf49r">{item.desc}</p>}
                    {item.items && <ul className="flex flex-col gap-1.5" data-id="element-77" data-mp="27c1yidhj8t9i">
                        {item.items.map((sub, j) => <li key={j} className="flex gap-2 text-[13px] leading-snug text-white/75" data-id="element-78" data-mp="2lccqxkyhqfws" data-mpi={j}>
                            <span style={{
                    color: accent
                  }} data-id="element-79" data-mp="2ubhsl05cmpd6">•</span>
                            <span data-id="element-80" data-mp="2u9n6hiiccr7i">{sub}</span>
                          </li>)}
                      </ul>}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}